<!--suppress HtmlUnknownTarget -->
<template lang="pug">
    div

        //- Navigation
        navigation(@toggle="$emit('toggle')")

        //- Content
        router-view

</template>

<script>
    import Navigation from '@/components/products/Navigation.vue'

    export default {

        components: { Navigation }

    }

</script>
